const NEWS_YEAR_FILTER_TITLE_DICTIONARY_TERM = 'cnhi-news-year-filter-title';
const NEWS_LINE_FILTER_TITLE_DICTIONARY_TERM = 'cnhi-news-line-filter-title';
const NEWS_TYPE_FILTER_TITLE_DICTIONARY_TERM = 'cnhi-news-type-filter-title';
const NEWS_FILTER1_FILTER_TITLE_DICTIONARY_TERM = 'cnhi-news-filter1-filter-title';

export {
  NEWS_YEAR_FILTER_TITLE_DICTIONARY_TERM,
  NEWS_LINE_FILTER_TITLE_DICTIONARY_TERM,
  NEWS_TYPE_FILTER_TITLE_DICTIONARY_TERM,
  NEWS_FILTER1_FILTER_TITLE_DICTIONARY_TERM,
};
